module.exports = __webpack_public_path__ + "static/media/menu_cancellationPolicy_default.ea779987.svg";